import React from 'react';
import ModalInner from '../../layoutItems/modalInner';
import { Translate, withLocalize } from 'react-localize-redux';
import ResponsiveTable from '../../layoutItems/responsiveTable';
import { IndexLabel, SemaphoreGroup } from '../../common/semaphors';
import { connect } from 'react-redux';
import { SECTIONS } from '../../../store/reportStore';

class RatingExplanatoryNotes extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate('Report.Explanatory.Header')} close={this.props.close}>
                <ResponsiveTable>
                    <table className="table table-report-section">
                        <thead>
                            <tr>
                                <th><Translate id='Report.Ratings.IndexCribis' /></th>
                                <th><Translate id='Report.Ratings.Explanatory.Risk' /></th>
                                <th><Translate id='Report.Ratings.Explanatory.FinEvalNote' /></th>
                                <th><Translate id='Report.Ratings.Explanatory.NonFinEvalNote' /></th>
                            </tr>
                        </thead>
                        <tbody>{
                            ['a1', 'a2', 'b1', 'b2', 'c1', 'c2', 'c3', 'd1', 'd2', 'e', 'na'].map((ratingCode, index) => (
                                <tr key={ratingCode} className='colorize'>
                                    <td data-label={this.props.translate('Report.Ratings.IndexCribis')}>
                                        <IndexLabel code={ratingCode} height='2.4em' padding='0.2em' />
                                    </td>
                                    <td data-label={this.props.translate('Report.Ratings.Explanatory.Risk')}>
                                        <span><Translate id={`Report.Ratings.10Star.${10 - index}`} /></span>
                                    </td>
                                    <td data-label={this.props.translate('Report.Ratings.Explanatory.FinEvalNote')}>
                                        <span><Translate id={`Report.Ratings.CribisIndexTooltip${10 - index}`} /></span>
                                    </td>
                                    <td data-label={this.props.translate('Report.Ratings.Explanatory.NonFinEvalNote')}>
                                        <span><Translate id={`Report.Ratings.Explanatory.NonFin${10 - index}`} /></span>
                                    </td>
                                </tr>
                            ))
                        }</tbody>
                    </table>
                </ResponsiveTable>
                <br />
                <ResponsiveTable>
                    <table className="table table-report-section">
                        <thead>
                            <tr>
                                <th><Translate id='Report.Ratings.SemaphoreCribis' /></th>
                                <th><Translate id='Report.Common.Note' /></th>
                            </tr>
                        </thead>
                        <tbody>{
                            ['Na', 'Plus', 'Neutral', 'Minus'].map((semaphore, index) => (
                                <tr key={semaphore} className='colorize'>
                                    <td className='always-new-line' data-label={this.props.translate('Report.Ratings.SemaphoreCribis')}>
                                        <SemaphoreGroup value={index} size='medium' className='explanatory' />
                                    </td>
                                    <td data-label={this.props.translate('Report.Common.Note')}><span>
                                        <Translate
                                            id={`Report.Ratings.Explanatory.SemaphoreCribis${semaphore}${this.getRatingData().country}`}
                                            options={{ renderInnerHtml: true }} />
                                    </span></td>
                                </tr>
                            ))
                        }</tbody>
                    </table>
                </ResponsiveTable>
                {this.renderExplanatoryDescription('Report.Ratings.Explanatory.GroupSemaphoreDesc')}
                {this.renderExplanatoryDescription('Report.Ratings.Explanatory.ITradeIndexDesc')}
                {this.renderExplanatoryDescription('Report.Ratings.Explanatory.SectorITradeIndexDesc')}
                {this.renderExplanatoryDescription('Report.Ratings.Explanatory.BankcruptcyProbabilityDesc')}
                {this.getRatingData().country === 'CZ' && (<>
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.ShortTermCreditLimitDesc')}
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.FinancialCriteriaDesc')}
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.SelectedFinancialRatiosDesc')}
                    <br />
                </>)}
                {this.getRatingData().country === 'SK' && (<>
                    <br />
                    <div className='hide-on-mobile'>
                        <ResponsiveTable>
                            <table className="table table-report-section without-hover">
                                <thead>
                                    <tr>
                                        <th><Translate id='Report.Ratings.PaymentDisciplineIndex' /></th>
                                        <th><Translate id='Report.Common.Note' /></th>
                                    </tr>
                                </thead>
                                <tbody>{
                                    this.generatePaymentDisciplineArray().map(index => index.subIndexes.map((subIndex, arrayIndex) => (
                                        <tr key={`${index.id}${subIndex}`}>
                                            <td>
                                                <span>{`${index.id}${subIndex}`}</span>
                                            </td>
                                            {arrayIndex === 0 && <td rowSpan={index.subIndexes.length}><span>
                                                <Translate
                                                    id={`Report.Ratings.Explanatory.PaymentDiscipline${index.id}`}
                                                    options={{ renderInnerHtml: true }} />
                                            </span></td>}
                                        </tr>
                                    )))
                                }</tbody>
                            </table>
                        </ResponsiveTable>
                    </div>
                    <div className='hide-on-desktop'>
                        <ResponsiveTable>
                            <table className="table table-report-section">
                                <tbody>{
                                    this.generatePaymentDisciplineArray().map(index => (
                                        <tr key={index.id}>
                                            <td data-label={this.props.translate('Report.Ratings.PaymentDisciplineIndex')}>
                                                <span>{index.subIndexes.map(subIndex => `${index.id}${subIndex}`).join(' ')}</span>
                                            </td>
                                            <td data-label={this.props.translate('Report.Common.Note')}><span>
                                                <Translate
                                                    id={`Report.Ratings.Explanatory.PaymentDiscipline${index.id}`}
                                                    options={{ renderInnerHtml: true }} />
                                            </span></td>
                                        </tr>
                                    ))
                                }</tbody>
                            </table>
                        </ResponsiveTable>
                    </div>
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.CreditLimitDesc')}
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.CribisIndexDesc')}
                    {this.renderExplanatoryDescription('Report.Ratings.Explanatory.PaymentDisciplineDesc')}
                    <br />
                    <ResponsiveTable>
                        <table className="table table-report-section">
                            <thead>
                                <tr>
                                    <th><Translate id='Report.Ratings.Explanatory.LiabilityType' /></th>
                                    <th><Translate id='Report.Common.Note' /></th>
                                </tr>
                            </thead>
                            <tbody>{
                                Array.apply(null, Array(9)).map((_, i) => (
                                    <tr key={i}>
                                        <td data-label={this.props.translate('Report.Ratings.Explanatory.LiabilityType')}>
                                            <span><strong><Translate id={`Report.Ratings.Explanatory.LiabilityTypeLabel${i}`} /></strong></span>
                                        </td>
                                        <td data-label={this.props.translate('Report.Common.Note')}>
                                            <span><Translate id={`Report.Ratings.Explanatory.LiabilityTypeValue${i}`} /></span>
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </ResponsiveTable>
                </>)}
            </ModalInner>
        )
    }

    renderExplanatoryDescription = translationId => (<>
        <br />
        <hr className='no-margin' />
        <Translate id={translationId} options={{ renderInnerHtml: true }} />
        <hr className='no-margin' />
    </>)

    getRatingData = () => this.props.sections.find(i => i.id === SECTIONS.ratingData).data;

    generatePaymentDisciplineArray = () => [
        { id: 'AAA', subIndexes: ['+', '', '-'] },
        { id: 'AA', subIndexes: ['+', '', '-'] },
        { id: 'A', subIndexes: ['+', '', '-'] },
        { id: 'BBB', subIndexes: ['+', '', '-'] },
        { id: 'BB', subIndexes: ['+', '', '-'] },
        { id: 'B', subIndexes: ['+', '', '-'] },
        { id: 'CCC', subIndexes: ['+', '', '-'] },
        { id: 'CC', subIndexes: ['+', '', '-'] },
        { id: 'C', subIndexes: ['+', '', '-'] },
        { id: 'D', subIndexes: [''] }
    ];
}

export default withLocalize(connect(state => state.report)(RatingExplanatoryNotes));